import { render } from "./IconWithHint.vue?vue&type=template&id=22d58392&scoped=true&ts=true"
import script from "./IconWithHint.vue?vue&type=script&lang=ts"
export * from "./IconWithHint.vue?vue&type=script&lang=ts"

import "./IconWithHint.vue?vue&type=style&index=0&id=22d58392&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d58392"]])

export default __exports__